export async function GetPerformanceCyclesApi() {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}v1/performance-cycles`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching performance cycles:', error);
    return { error: true, message: error.message || 'Failed to fetch performance cycles' };
  }
}
